import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

// components
import { RightArrow } from "components/common";
import Text from "components/ui/Text";
import Button from "components/entrance/Button";
import { Switch } from "components/form";

// theme
import { theme } from "styles";

// hooks
import useKakaoChannel from "hooks/useKakaoChannel";
import { updateMarketingAgreeSettings } from "redux/slices/user/userSlice";
import { applyHighlight } from "utils/applyHighlight";

const MenuSections = ({ sections, state, info, page, onDoorOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleClickOpenKakao } = useKakaoChannel();
  const { userInfo } = useSelector((state) => state.user);

  const [marketingPushAgree, setMarketingPushAgree] = useState(
    !!userInfo.marketingDtm
  );

  useEffect(() => {
    setMarketingPushAgree(!!userInfo.marketingDtm);
  }, [userInfo.marketingDtm]);

  const handleMarketingToggle = (e) => {
    const checked = e.target.checked;
    const marketingYN = checked ? "Y" : "N";
    dispatch(updateMarketingAgreeSettings({ value: marketingYN }));
  };

  if (page === "terms") {
    return (
      <SectionsList>
        {sections.map((section, index) => (
          <Section
            key={index}
            onClick={() =>
              navigate(section.to, {
                state: {
                  label: section.label.replace(" (보기)", ""),
                  name: section.name,
                },
              })
            }
          >
            <p>{applyHighlight("(보기)", section.label)}</p>
            <RightArrow />
          </Section>
        ))}
        <Switch
          value="marketingPushAgree"
          label="마케팅 활용 및 광고성 정보 수신"
          checked={marketingPushAgree}
          onChange={handleMarketingToggle}
        />
      </SectionsList>
    );
  }

  if (page === "setting") {
    return (
        <SectionsList>
          {sections.map((section, index) => {
            // 링크 이동 메뉴
            if (section.to) {
              return (
                  <Section
                      key={index}
                      onClick={() =>
                          navigate(section.to, { state: { ...state, ...info } })
                      }
                  >
                    <p>{section.label}</p>
                    <RightArrow />
                  </Section>
              );
            }

            // 출입문 제어 메뉴
            if (section.action === "openDoor") {
              return (
                  <Section key={index}>
                    <p>{section.label}</p>
                    {/* 화살표 대신 버튼 */}
                    <DoorButton onClick={onDoorOpen}>출입문 열기</DoorButton>
                  </Section>
              );
            }

            return null;
          })}
        </SectionsList>
    );
  }

  return (
    <SectionsList>
      <SectionsBox>
        {sections.slice(0, 2).map((section, index) => (
          <Section key={index} onClick={() => navigate(section.to)}>
            <p>{section.label}</p>
            <RightArrow />
          </Section>
        ))}
      </SectionsBox>
      <SectionsBox>
        {sections.slice(2, 4).map((section, index) => {
          if (section.label === "앱 버전") {
            return (
              <Section key={index}>
                <p>{section.label}</p>
                <p style={{ color: theme.colors["gray50"] }}>1.0.0</p>
              </Section>
            );
          }
          return (
            <Section key={index} onClick={() => navigate(section.to)}>
              <p>{section.label}</p>
              <RightArrow />
            </Section>
          );
        })}
      </SectionsBox>
      <SectionsBox>
        <SectionCs>
          <Text lineHeight="24px">고객센터</Text>
          <Text
            color="gray40"
            lineHeight="24px"
            css={css`
              margin: 8px 0 16px;
            `}
          >
            서비스 관련 문의는 바디코디 카카오 고객센터 챗봇을 이용해주세요
          </Text>
          <Button
            color="primary50"
            border="primary50"
            background="white"
            onClick={handleClickOpenKakao}
            css={css`
              border-radius: 8px;
            `}
          >
            서비스 문의하기
          </Button>
        </SectionCs>
      </SectionsBox>
    </SectionsList>
  );
};

const SectionsList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  & > div > h4 {
    font-weight: 500;
  }
`;

const SectionsBox = styled.div`
  & + & {
    margin-top: 16px;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 56px;

  p {
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: ${(props) => props.theme.primaryTextColor};
  }
`;

const SectionCs = styled.div`
  padding: 16px 0;
`;

const DoorButton = styled.button`
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  color: #0066ff;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f5f9ff;
  }
`;

export default MenuSections;
